import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import CardMedia from '@mui/material/CardMedia';

// import p1 from 'assests/Photos/Clubs/CulturalClub/Cultural_heritage.jpg';
// import p2 from 'assests/Photos/Clubs/ExpressionClub/Expression.jpg';
// import p3 from 'assests/Photos/Clubs/RoboticsClub/Robotics.jpg';
// import p4 from 'assests/Photos/Clubs/YuvatourismClub/Yuva_tourism.jpg';







const Clubs = ()=> {

    const [config, setConfig] = useState({ base_image_url: '' });
    useEffect(() => {
      fetch('/config.json')
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
  
    const p1 = `${config.base_image_url}/home/home-static/static-images/all-static-images/Clubs/CulturalClub/Cultural_heritage.webp`;
    const p2 = `${config.base_image_url}/home/home-static/static-images/all-static-images/Clubs/ExpressionClub/Expression.webp`;
    const p3 = `${config.base_image_url}/home/home-static/static-images/all-static-images/Clubs/RoboticsClub/Robotics.webp`;
    const p4 = `${config.base_image_url}/home/home-static/static-images/all-static-images/Clubs/YuvatourismClub/Yuva_tourism.webp`;
    
  

  const theme = useTheme();
  const { mode } = theme.palette;

  const mock = [
    {
      media: 'https://1.bp.blogspot.com/-GFVSU2IMPTs/YDzP0jUblgI/AAAAAAAABYU/biaHILeEviInZz1OF_9mL2MAzBSzM5s_gCLcBGAsYHQ/s320/WhatsApp%2BImage%2B2021-02-14%2Bat%2B10.30.31%2BPM.jpeg',
      href: '/eco-club-class7-2026',
      companyLogo:
        'https://www.svgrepo.com/show/118643/eco-leaf.svg',
      description:
        'Eco',
    }, 
    {
      media: p1,
      href: '/talent-show-2024',
      companyLogo:p1,
      description:
        'Cultural Heritage Club',
    },
    {
      media: 'https://i.pinimg.com/originals/73/29/ec/7329ec81dcceead61217a205c941a3b3.jpg',
      href: '/dengue-prevention',
      companyLogo:
        'https://i.pinimg.com/originals/73/29/ec/7329ec81dcceead61217a205c941a3b3.jpg',
      description:
        'Health & Wellness Club',
    },
    {
      media: p4,
      href: '/national-space-day-celebration',
      companyLogo:p4,
      description:
        'YUVA Tourism Club',
    },
    {
      media: p2,
      href: '/times-nie-2025',
      companyLogo:
        p2,
      description:
        'Expression Series Club', 
    },
    {
      media: 'https://cdn.vectorstock.com/i/preview-1x/81/64/election-icon-vector-14568164.webp',
  
      href: '/ClassLeader-6to8-2026',
      companyLogo:
        'https://cdn.vectorstock.com/i/preview-1x/81/64/election-icon-vector-14568164.webp',
      description:
        'Electoral Club',
    },
    {
      media: p3,
  
      href: '/robotics-and-artificial-intelligence-2024',
      companyLogo:
        p3,
      description:
        'Robotics Club',
    },
     {
    media: 'https://cdn2.vectorstock.com/i/1000x1000/63/41/book-icon-logo-design-vector-28056341.jpg',
    href: '/reading-day-2026',
    companyLogo:
      'https://cdn2.vectorstock.com/i/1000x1000/63/41/book-icon-logo-design-vector-28056341.jpg',
    description:
      'Reading Club',
  },
  
  ];
  

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{
            fontWeight: 700 
          }}
          gutterBottom
          // color={'secondary'}
          align={'center'}
          variant={'h4'}
          
        >
          Our Clubs
        </Typography>
        <br />
        {/* <Box
          component={Typography}
          fontWeight={700}
          variant={'h6'}
          align={'center'}
        >
          See how we are involving in 
          <br />
          various activities
        </Box> */}
      </Box>
      <Grid container spacing={4}>
        {mock.map((item, i) => (
          <Grid item xs={12} sm={6} md={4} key={i}>
            <a href={item.href} style={{ textDecoration: 'none', color: 'black' }} >
            <Box
              // component={'a'}
              href={''}
              display={'block'}
              width={1}
              height={1}
              sx={{
                textDecoration: 'none',
                transition: 'all .2s ease-in-out',
                '&:hover': {
                  transform: `translateY(-${theme.spacing(1 / 2)})`,
                },
              }}
            >
              <Box
                component={Card}
                width={1}
                height={1}
                borderRadius={2}
                display={'flex'}
                flexDirection={'column'}
              >
                
                <CardMedia
                  image={item.media}
                  component = 'img'
                  sx={{
                    height: 240,
                  }}
                />
                
                <Box component={CardContent}>
                  <Box maxWidth={100} marginY={2}>
                    <Box
                      component="img"
                      height={1}
                      width={1}
                      src={item.companyLogo}
                      alt="..."
                      sx={{
                        filter: mode === 'dark' ? 'contrast(0)' : 'none',
                      }}
                    />
                  </Box>
                  <Typography
                    variant={'h6'}
                    gutterBottom
                    align={'left'}
                    sx={{ fontWeight: 700 }}
                  >
                    {item.description}
                  </Typography>
                </Box>
                
                <Box flexGrow={1} />
                <Box component={CardActions} justifyContent={'flex-start'}>
                  {/* <Button
                    size="large"
                    href= {item.href}
                    endIcon={
                      <svg
                        width={16}
                        height={16}
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17 8l4 4m0 0l-4 4m4-4H3"
                        />
                      </svg>
                    }
                  >
                    Learn More
                  </Button> */}
                </Box>
              </Box>
            </Box>
            </a>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Clubs;
